import React from "react";
import Header from "./customer/Header";
import AppFooter from "./customer/AppFooter";
import HomeHeader from "./customer/HomeHeader";

const PricingPolicy = () => {
  const access = localStorage.getItem("accessToken");

  console.log("Access Token:", access);
  return (
    <div>
      {access ? <Header /> : <HomeHeader />}
      <div className="py-10 px-4 sm:px-10 bg-gray-50 min-h-screen">
        {/* Page Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-center text-[#9061DB] mb-8">
          Pricing Policy
        </h1>

        {/* Policy Card */}
        <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 sm:p-10 text-gray-700 leading-relaxed space-y-4">
          <p>
            At GKS Infotech, we are committed to providing top-quality technical
            services through our <strong>Onzitr</strong> platform. To ensure
            transparency and clarity for our valued customers, we have
            established the following pricing policy:
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">
            Care Packs
          </h2>
          <p>
            We offer a variety of Care packs, each designed to meet different
            technical needs. The pricing for each service pack is clearly
            displayed on our website and in the Onzitr app.
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">
            Payment Methods
          </h2>
          <p>
            We accept various payment methods, including credit/debit cards,
            digital wallets, and other online payment options. Payment details
            and options will be provided during the checkout process.
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">
            Subscription Plans
          </h2>
          <p>
            Some of our Care packs may be offered on a subscription basis, with
            recurring billing. You can choose the billing frequency that best
            suits your needs (e.g., monthly, quarterly, or annually).
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">
            Promotions and Discounts
          </h2>
          <p>
            From time to time, we may offer promotions or discounts on our Care
            packs. These offers will be clearly communicated on our website, and
            any applicable discounts will be automatically applied during the
            checkout process.
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">Taxes</h2>
          <p>
            Prices listed on our website do not include applicable taxes, which
            may vary depending on your location. The final price, including
            taxes, will be displayed before you complete your purchase.
          </p>

          <h2 className="text-xl font-semibold text-[#9061DB] mt-4">
            Price Changes
          </h2>
          <p>
            GKS Infotech reserves the right to adjust the prices of our service
            packs at any time. However, if you have an active subscription, your
            pricing will remain unchanged for the duration of your subscription
            term.
          </p>
        </div>
      </div>
      <AppFooter></AppFooter>
    </div>
  );
};

export default PricingPolicy;
